import React from "react";
import { reduxForm, Field } from "redux-form";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { submitPassword } from "../actions/account";
import {
    asyncValidatePassword,
    validatePassword
} from "../validate/resetPassword";

const renderField = props => {
    const {
        input,
        label,
        type,
        meta: { touched, error }
    } = props;
    const classes = ["form-group"];
    return (
        <div
            className={
                touched && error
                    ? classes.concat(["has-error", "has-feedback"]).join(" ")
                    : classes.join(" ")
            }
        >
            <label className="control-label sr-only">{label}</label>
            <input
                className="form-control"
                {...input}
                placeholder={label}
                type={type}
                aria-describedby={`${label}Status`}
            />
            {touched && error && (
                <span
                    className="glyphicon glyphicon-remove form-control-feedback"
                    aria-hidden="true"
                />
            )}
            {/* { touched && error && <small id={`${label}Status`}>{ error }</small> } */}
        </div>
    );
};

const EditUserAgent = ({ handleSubmit, lang }) => (
    <form onSubmit={handleSubmit}>
        <div>
            <div className="formgroupep">
                <div className="row">
                    <div className="col-xs-4">
                        <div className="tag-input-name">
                            {lang[lang.locales].forms.changePassword.password}*
                        </div>
                    </div>
                    <div className="col-xs-8">
                        <div className="input-name">
                            <Field
                                component={renderField}
                                type="password"
                                name="Password"
                                label={`${
                                    lang[lang.locales].forms.changePassword
                                        .password
                                }`}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="formgroupep">
                <div className="row">
                    <div className="col-xs-4">
                        <div className="tag-input-name">
                            {
                                lang[lang.locales].forms.changePassword
                                    .newPassword
                            }
                            *
                        </div>
                    </div>
                    <div className="col-xs-8">
                        <div className="input-name">
                            <Field
                                component={renderField}
                                type="password"
                                name="NewPassword"
                                label={`${
                                    lang[lang.locales].forms.changePassword
                                        .newPassword
                                }`}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="formgroupep">
                <div className="row">
                    <div className="col-xs-4">
                        <div className="tag-input-name">
                            {
                                lang[lang.locales].forms.changePassword
                                    .newPasswordConfirm
                            }
                            *
                        </div>
                    </div>
                    <div className="col-xs-8">
                        <div className="input-name">
                            <Field
                                component={renderField}
                                type="password"
                                name="NewPasswordConfirm"
                                label={`${
                                    lang[lang.locales].forms.changePassword
                                        .newPasswordConfirm
                                }`}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="formbutton">
                <div className="row">
                    <div className="col-xs-12">
                        <button>
                            {lang[lang.locales].forms.changePassword.save}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </form>
);

const mapStateToProps = state => {
    return {
        lang: state.lang
    };
};

const mapDispatchToProps = (dispatch, { history }) => {
    return {
        onSubmit: values =>
            dispatch(
                submitPassword({
                    values,
                    history
                })
            )
    };
};

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(
        reduxForm({
            form: "changePassword",
            validate: validatePassword,
            asyncValidate: asyncValidatePassword,
            asyncBlurFields: ["Password", "NewPassword", "NewPasswordConfirm"]
        })(EditUserAgent)
    )
);
